import {v} from '../validation';
import {WordpressPageDto} from '../../types/dto/page';
import {Result} from '@/lib/utils/result';
import {ArchivePostBlurb, ArchivePost} from '@/lib/types/archivePost';

const ARCHIVE_POST_VALIDATION = v.object<ArchivePost>({
  id: v.number('id').required(),
  title: v.string('title'),
  seoMetaDescription: v.string('acf.seo.meta_description'),
  slug: v.string('slug'),
  selectHeading: v.string(
    'acf.select_top_level_page_component.select_component'
  ),
  headingSplash: v.string(
    'acf.select_top_level_page_component.home_page_splash.heading'
  ),
  headingHero: v.string(
    'acf.select_top_level_page_component.hero_section.heading'
  ),
  description: v.string('acf.hero_section_search_data.description'),
  content: v.array(
    'acf.find_data_content',
    v.object<ArchivePostBlurb>({
      afcLayout: v.string('acf_fc_layout'),
      pageContent: v.string('page_content'),
    })
  ),
  featuredMediaId: v.number('featured_media').optional(),
  createdDate: v
    .string<Date>('date')
    .transform((date: string) => new Date(date))
    .optional(),
  categories: v.array('categories', v.number()),
  generic_post_categories: v.array('generic-post-category', v.number()),
  acfSearchableText: v.string('meta.acf_searchable_text'),
});

export function transformArchivePosts(
  archivePosts: WordpressPageDto[]
): Result<ArchivePost[]> {
  const validator = v.array(ARCHIVE_POST_VALIDATION);
  return validator.safeParse(archivePosts);
}
